var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap',{ref:"wrap",attrs:{"title":_vm.title}},[_c('CTable',{attrs:{"head":_vm.head,"body":_vm.body},scopedSlots:_vm._u([{key:"change_money",fn:function(ref){
var data = ref.data;
return [_c('span',{style:({'color':data.change_money<0?'green' : data.change_money > 0 ? 'red' : ''})},[_vm._v(_vm._s(data.change_money))])]}},{key:"change_type",fn:function(ref){
var data = ref.data;
return [_c('span',[_vm._v(_vm._s(_vm.change_type[data.change_type]))])]}},{key:"addtime",fn:function(ref){
var data = ref.data;
return [_c('span',[_vm._v(_vm._s(_vm._f("formatDate")(data.addtime)))])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6475828","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/QC22.vue
// module id = null
// module chunks = 